import type NumberUnit from '@exodus/currency';
import { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import getAvailableBalanceSelector from '@/ui/flux/balances/selectors/get-available-balance';

type UseAvailableBalanceParams = {
  assetName: string;
  fees: { fee: NumberUnit };
  walletAccount: string;
};

const useAvailableBalance = ({
  assetName,
  fees,
  walletAccount,
}: UseAvailableBalanceParams) => {
  const getAvailableBalance = useSelector(getAvailableBalanceSelector);

  const previousCalculatedBalance = useRef<NumberUnit>();

  return useMemo(() => {
    const balance = getAvailableBalance({ assetName, walletAccount }, fees);
    if (!balance) {
      return;
    }

    if (
      previousCalculatedBalance.current &&
      balance.equals(previousCalculatedBalance.current)
    ) {
      return previousCalculatedBalance.current;
    }

    previousCalculatedBalance.current = balance;
    return balance;
  }, [assetName, fees, getAvailableBalance, walletAccount]);
};

export default useAvailableBalance;
